export default {
  title: 'Télécharger l\'application',
  author: ' iA Gestion privée',
  buttonLabel: 'Installer',
  closeButtonLabel: 'Fermer',
};
